<div class="d-flex flex-column justify-content-center dialog-container">
  <div class="d-flex justify-content-end" >
    <img class="cursor-pointer" [src]="'assets/svg-icons/close.svg'" alt="" (click)="dialogRef.close()" data-cy="confirmation-no"/>
  </div>
  <div class="d-flex flex-column justify-content-center ps-2 pe-2">
    <span class="d-flex title justify-content-center text-center">{{'offer.refillOfferModal.headline'|translate: {offerNumber: this.offerNumber} }}</span>
    <div class="body-text-wrapper">
      <img class="mr-1 align-content-center" src="assets/svg-icons/circle-actions-alert-info.svg" style="width: 30px; height: 30px;" alt="">
      <span class="body-text text-center font-weight-700">{{'offer.refillOfferModal.content'|translate: {offerNumber: this.offerNumber} }}</span>
    </div>
  </div>
  <div class="d-flex ps-2 pe-2 gap-2 w-100 mt-4 mb-3">
    <button class="close-button" (click)="dialogRef.close()" data-cy="confirmation-no">{{'offer.refillOfferModal.cancelButton'|translate}}</button>
    <button class="confirm-button" [mat-dialog-close]="true" cdkFocusInitial data-cy="confirmation-yes">{{'offer.refillOfferModal.acceptButton'|translate}}</button>
  </div>
</div>

